import {throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import {JsonService} from '../../../services/core/json.service';
import {JobApiResources} from "./job.constants";

@Injectable({
  providedIn: 'root'
})


export class JobDataService {
  private baseURL:any;

  constructor(
    private http: HttpClient,
    private jsonService: JsonService,
  ) {
    this.baseURL = JobApiResources;
  }

  list(model: any): Observable<any> {
    const endPoint = `${this.baseURL.list}`;
    return this.http.post<any>(endPoint, model)
                    .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  search(model: any): Observable<any> {
    const endPoint = `${this.baseURL.search}`;
    return this.http.post<any>(endPoint, model)
                    .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  create(model: any): Observable<any> {
    const endPoint = `${this.baseURL.create}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  // detail(id:any): Observable<any> {
  //   const endPoint = `${this.baseURL.detail}/${id}`;
  //   return this.http.get<any>(endPoint)
  //     .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  // }

  detail(id: any, params?: any): Observable<any> {
    const endPoint = `${this.baseURL.detail}/${id}`;
    return this.http.get<any>(endPoint, { params })
      .pipe(
        tap(data => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage)
      );
  }

  update(id:any, model: any): Observable<any> {
    const endPoint = `${this.baseURL.update}/${id}`;
    return this.http.patch<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  delete(id:any): Observable<any> {
    const endPoint = `${this.baseURL.delete}/${id}`;
    return this.http.delete<any>(endPoint)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  // Bulk delete: DELETE jobs/delete/multiple with { job_ids: [...] }
  deleteMultiple(jobIds: any[]): Observable<any> {
    const endPoint = `${this.baseURL.deleteMultiple}`;
    return this.http.request<any>('delete', endPoint, { body: { job_ids: jobIds } })
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  // Pre-check which of the selected jobs can be deleted (and why not, for the rest)
  deleteAvailability(jobIds: any[]): Observable<any> {
    const endPoint = `${this.baseURL.deleteAvailability}`;
    return this.http.post<any>(endPoint, { job_ids: jobIds })
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  assingJob(model: any): Observable<any> {
    const endPoint = `${this.baseURL.assingJob}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  assingPeople(model: any): Observable<any> {
    const endPoint = `${this.baseURL.assingJob}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  removeFromJob(jobID:any, id:any): Observable<any> {
    const endPoint = `${this.baseURL.removeFromJob}/${jobID}/${id}`;
    return this.http.delete<any>(endPoint)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  getStatus(): Observable<any> {
    const endPoint = `${this.baseURL.statusList}`;
    return this.http.get<any>(endPoint)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  getTaskType(): Observable<any> {
    const endPoint = `${this.baseURL.taskTypeList}`;
    return this.http.get<any>(endPoint)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  onChangeStatus(id:any, model: any): Observable<any> {
    const endPoint = `${this.baseURL.changeStatus}/${id}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  updateDates(id: any, dates: any): Observable<any> {
    // Use the existing job update endpoint instead of /dates
    const endPoint = `${this.baseURL.update}/${id}`;

    // Prepare payload with both standard and YMD format fields
    const payload: any = {
      start_date: dates.start_date,
      //start_date_YMD: dates.start_date,
      deadline: dates.deadline,
      //deadline_YMD: dates.deadline
    };

    // Include reason if provided
    if (dates.reason) {
      payload.date_change_reason = dates.reason;
    }

    return this.http.patch<any>(endPoint, payload)
      .pipe(
        tap(data => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage)
      );
  }

  getDateHistory(id: any): Observable<any> {
    // Date history endpoint not implemented in backend yet
    // Return empty observable with empty data array
    return new Observable(observer => {
      observer.next({ data: [] });
      observer.complete();
    });

    // When backend implements this endpoint, uncomment:
    // const endPoint = `${this.baseURL.detail}/${id}/date-history`;
    // return this.http.get<any>(endPoint)
    //   .pipe(
    //     tap(data => this.jsonService.doStringify(data)),
    //     catchError(this.errorHandlerMessage)
    //   );
  }

  validateDates(dates: any): Observable<any> {
    const endPoint = `${this.baseURL.list}/validate-dates`;
    return this.http.post<any>(endPoint, dates)
      .pipe(
        tap(data => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage)
      );
  }
  updateUnionOptions(id:any, model: any): Observable<any> {
    model.loadingService = false;
    const endPoint = `${this.baseURL.updateUnionOptions}/${id}`;
    return this.http.patch<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  updateDepositStatus(model: any): Observable<any> {
    model.loadingService = false;
    const endPoint = `${this.baseURL.updateDepositStatus}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  updatePurchaseOrder(id:any, model: any): Observable<any> {
    model.loadingService = false;
    const endPoint = `${this.baseURL.updatePurchaseOrder}/${id}`;
    return this.http.patch<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  costDrillDown(id:any,scope: number = 1): Observable<any> {
    const endPoint = `${this.baseURL.costDrillDown}/${id}?scope=${scope}`;
    return this.http.get<any>(endPoint)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }


  assignJobRole(model: any): Observable<any> {
    const endPoint = `${this.baseURL.assignJobRole}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  getLineItems(jobId: number, params?: any): Observable<any> {
    const endPoint = `${this.baseURL.lineItems}/${jobId}/line-items`;

    // Clean up params - remove undefined values
    const cleanParams = params ? Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== null && value !== '')
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {}) : {};

    return this.http.get<any>(endPoint, { params: cleanParams })
      .pipe(
        tap(data => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage)
      );
  }

  getJobScopes(jobId: number): Observable<any> {
    const endPoint = `${this.baseURL.getScopes}/${jobId}`;
    return this.http.get<any>(endPoint)
      .pipe(
        tap(data => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage)
      );
  }

  /**
   * Mark an exact quantity ready on specific material lines.
   * Line-level payload: the endpoint also accepts the older `material_ids` shape, which marks a
   * whole product across every scope of the job.
   */
  markMaterialLinesReady(jobId: number, items: Array<{ job_scope_item_id: number; quantity: number }>): Observable<any> {
    const endPoint = `${this.baseURL.getMaterials}/${jobId}/materials/mark-ready`;
    return this.http.post<any>(endPoint, { items })
      .pipe(tap(data => (this.jsonService.doStringify(data))), catchError(this.errorHandlerMessage));
  }

  /** Release an exact quantity of marked-ready material for ordering, line by line. */
  releaseMaterialLinesForOrdering(
    jobId: number,
    items: Array<{ job_scope_item_id: number; quantity: number }>,
  ): Observable<any> {
    const endPoint = `${this.baseURL.getMaterials}/${jobId}/materials/ready-to-order`;
    return this.http.post<any>(endPoint, { items })
      .pipe(tap(data => (this.jsonService.doStringify(data))), catchError(this.errorHandlerMessage));
  }

  /**
   * Record the field measurement on material lines — the step between mark ready and ready to
   * order. A line is dispositioned as a whole, so there is no quantity here.
   */
  setMaterialLinesFieldMeasurement(
    jobId: number,
    items: Array<{ job_scope_item_id: number; status: string; note?: string | null }>,
  ): Observable<any> {
    const endPoint = `${this.baseURL.getMaterials}/${jobId}/materials/field-measurement`;
    return this.http.post<any>(endPoint, { items })
      .pipe(tap(data => (this.jsonService.doStringify(data))), catchError(this.errorHandlerMessage));
  }

  getJobMaterials(jobId: number, search?: string): Observable<any> {
    let endPoint = `${this.baseURL.getMaterials}/${jobId}/material`;
    if (search) {
      endPoint += `?search=${encodeURIComponent(search)}`;
    }
    return this.http.get<any>(endPoint)
      .pipe(
        tap(data => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage)
      );
    }
  updateSiteInfo(id:any, model: any): Observable<any> {
    const endPoint = `${this.baseURL.updateSiteInfo}/${id}`;
    return this.http.patch<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  getJobsiteRequirements(): Observable<any> {
    const endPoint = `${this.baseURL.getJobsiteRequirements}`;
    return this.http.get<any>(endPoint)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  getJobsiteAccesses(params: any): Observable<any> {
    const endPoint = `${this.baseURL.getJobsiteAccesses}`;
    return this.http.get<any>(endPoint, { params })
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  createJobsiteAccess(model: any): Observable<any> {
    const endPoint = `${this.baseURL.createJobsiteAccess}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  getJobsiteParking(params: any): Observable<any> {
    const endPoint = `${this.baseURL.getJobsiteParking}`;
    return this.http.get<any>(endPoint, { params })
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  createJobsiteParking(model: any): Observable<any> {
    const endPoint = `${this.baseURL.createJobsiteParking}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  createJobsite(model: any): Observable<any> {
    const endPoint = `${this.baseURL.createJobsite}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  getJobsites(jobId: number): Observable<any> {
    let endPoint = `${this.baseURL.getJobsites}`;
    endPoint = endPoint.replace('{job_id}', jobId.toString());
    return this.http.get<any>(endPoint).pipe(
      tap((data) => this.jsonService.doStringify(data)),
      catchError(this.errorHandlerMessage)
    );
  }

  // Cancel Job & Rebid with Another Bidder — archives this job, marks its
  // awarded proposal Lost, snapshots the bid into history. The caller follows
  // a successful response with the existing Convert to Job flow for the new proposal.
  cancelAndRebid(id: any, newProposalId: number, reason?: string | null): Observable<any> {
    const endPoint = `${this.baseURL.cancelAndRebid}/${id}/cancel-rebid`;
    return this.http.post<any>(endPoint, { new_proposal_id: newProposalId, reason })
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  // Safety net: puts a cancelAndRebid()'d job back the way it was when the
  // Convert to Job step that follows it fails, instead of leaving the job
  // cancelled with no replacement created.
  undoCancelAndRebid(id: any): Observable<any> {
    const endPoint = `${this.baseURL.undoCancelAndRebid}/${id}/undo-cancel-rebid`;
    return this.http.post<any>(endPoint, {})
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  // Cancel Job (simple) — closes the job (status change only, stays in the
  // Jobs list) and resets its proposal to default status, ready to work from
  // scratch again.
  cancelJobSimple(id: any, reason?: string | null): Observable<any> {
    const endPoint = `${this.baseURL.cancelJobSimple}/${id}/cancel-simple`;
    return this.http.post<any>(endPoint, { reason })
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  // Cancel Job, proposal Lost — archives the job and its related data, marks
  // its proposal Lost. The bid itself is left untouched.
  cancelJobLostProposal(id: any, reason?: string | null): Observable<any> {
    const endPoint = `${this.baseURL.cancelJobLostProposal}/${id}/cancel-lost-proposal`;
    return this.http.post<any>(endPoint, { reason })
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  errorHandler(error: HttpErrorResponse) {
    return observableThrowError(error.error || 'Server Error');
  }

  errorHandlerMessage(error: HttpErrorResponse) {
    return observableThrowError(error.error || 'Server Error');
  }
}
